import { render, staticRenderFns } from "./detailPure_m.vue?vue&type=template&id=f22b6f4e"
import script from "./detailPure_m.vue?vue&type=script&lang=js"
export * from "./detailPure_m.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports